<div class="modal-header">
  <h4 class="modal-title">Expire Gift Immediately</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="serverError !== null">
  <h2>Server error: {{ serverError }}</h2>
</div>

<div class="modal-body pb-0" *ngIf="serverError === null">

  <div class="alert alert-warning">
    The gift cannot be redeemed after making this change.
  </div>

  <div class="form-group">
    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="refundLastPayment" id="refundLastPaymentNo"
             [(ngModel)]="willRefund" [value]="false">
      <label class="form-check-label" for="refundLastPaymentNo">
        No refund
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="refundLastPayment" id="refundLastPaymentYes"
             [(ngModel)]="willRefund" [value]="true">
      <label class="form-check-label" for="refundLastPaymentYes">
        Refund gift purchase
      </label>
    </div>
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
  <button type="button" class="btn btn-primary"
          *ngIf="!loading && !serverError"
          (click)="onSubmit()">
    Submit
  </button>
  <button type="button" class="btn btn-primary disabled" disabled
          *ngIf="loading">
    Loading...
  </button>
</div>
